import { render, staticRenderFns } from "./PageSettingsModal.vue?vue&type=template&id=7d20b5c1&"
import script from "./PageSettingsModal.vue?vue&type=script&lang=js&"
export * from "./PageSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports